module.exports = __webpack_public_path__ + "img/5_16.a549ac55.png";